<template>
    <tbody class="divide-y divide-taupe-200 bg-white">
        <slot />
    </tbody>
</template>

<script setup>
defineOptions({
    name: 'ZenGridBody',
})
</script>
